import "./ModalBox.css"; // dùng cùng CSS cũ hoặc tạo mới nếu muốn tách biệt

const ModalBox = ({ title, children, onClose, className }) => {
  return (
    <div className={`modal ${className || ""}`}>
      {title && <h3>{title}</h3>}
      {children}
    </div>
  );
};

export default ModalBox;
